/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Representation of a Delivery Order Entry Group
 * @export
 * @interface DeliveryOrderEntryGroup
 */
export interface DeliveryOrderEntryGroup {
    /**
     * 
     * @type {Price}
     * @memberof DeliveryOrderEntryGroup
     */
    totalPriceWithTax?: Price;
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof DeliveryOrderEntryGroup
     */
    entries?: Array<OrderEntry>;
    /**
     * Quantity of order entries in a group
     * @type {number}
     * @memberof DeliveryOrderEntryGroup
     */
    quantity?: number;
    /**
     * 
     * @type {Address}
     * @memberof DeliveryOrderEntryGroup
     */
    deliveryAddress?: Address;
}

/**
 * Check if a given object implements the DeliveryOrderEntryGroup interface.
 */
export function instanceOfDeliveryOrderEntryGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryOrderEntryGroupFromJSON(json: any): DeliveryOrderEntryGroup {
    return DeliveryOrderEntryGroupFromJSONTyped(json, false);
}

export function DeliveryOrderEntryGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryOrderEntryGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceFromJSON(json['totalPriceWithTax']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'deliveryAddress': !exists(json, 'deliveryAddress') ? undefined : AddressFromJSON(json['deliveryAddress']),
    };
}

export function DeliveryOrderEntryGroupToJSON(value?: DeliveryOrderEntryGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPriceWithTax': PriceToJSON(value.totalPriceWithTax),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'quantity': value.quantity,
        'deliveryAddress': AddressToJSON(value.deliveryAddress),
    };
}

